/* eslint-disable import/no-default-export */
import LazyImage from './LazyImage/LazyImage';

export default LazyImage;
